var isNull = function (value) {
    return value === null;
};
export default isNull;
//# sourceMappingURL=is-null.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-null.js
// module id = 496
// module chunks = 3